import { render } from "./DecorationBar.vue?vue&type=template&id=6850e1a6&scoped=true"
import script from "./DecorationBar.vue?vue&type=script&lang=js"
export * from "./DecorationBar.vue?vue&type=script&lang=js"

import "./DecorationBar.vue?vue&type=style&index=0&id=6850e1a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6850e1a6"]])

export default __exports__